import React from "react";

import CommunicationAnswerPage from "pages/communication/CommunicationAnswerPage";
import { communicationAnswerConfigs } from "pages/communication/model/communicationAnswerConfigs";

function SuggestionAnswer() {
  return (
    <CommunicationAnswerPage
      config={communicationAnswerConfigs.suggestion}
    />
  );
}

export default SuggestionAnswer;
